import {Route, Switch, Redirect} from 'react-router-dom';
import React from 'react';
import {v4 as UUIDGenerator} from 'uuid';

import EventForm from '../screens/Forms/EventForm';
import EventFormDrafts from '../screens/Forms/EventFormDrafts/EventFormDrafts';
import EventFormResponse from '../screens/Forms/EventFormResponse/EventFormResponse';
import EventFormSelection from '../screens/Forms/EventFormSelection/EventFormSelection';
import LoadEventFormsMetadata from '../loaders/LoadEventFormsMetadata';

import _ from 'lodash';

const CreateFormAnswer = props => {
    let uuid = UUIDGenerator();
    app.store.dispatch(app.actions.forms.createResponse(props.match.params.eventId, props.match.params.formId, uuid));
    return <Redirect to={`./${uuid}`} />;
};
const DraftsOrAnswerDisambiguation = props => {
    let state = app.store.getState(),
        formId = props.match.params.formId,
        hasAnswers = !!_(state.forms.drafts)
            .values()
            .find(draft => draft.formId == formId);

    if (hasAnswers) {
        return <EventForm {...props} />;
    } else {
        return <Redirect to={`${props.match.url}/create`} />;
    }
};
const formRoutes = props => (
    <LoadEventFormsMetadata eventId={props.match.params.eventId}>
        <Switch>
            <Route path={`${props.match.path}/create`} exact component={CreateFormAnswer} />
            <Route path={`${props.match.path}/:formAnswer`} exact component={EventFormResponse} />
            <Route path={`${props.match.path}`}  exact component={DraftsOrAnswerDisambiguation} />
            <Redirect to={`..`} />
        </Switch>
    </LoadEventFormsMetadata>
);

export default props => (
    <Switch>
        <Route path={`${props.match.path}/drafts`} exact component={EventFormDrafts} />
        <Route path={`${props.match.path}/:formId`} component={formRoutes} />
        <Route path={`${props.match.path}`} exact component={EventFormSelection} />
        <Redirect to={`${props.match.url}`} />
    </Switch>
);
